import { render } from "./StudioAvatar.vue?vue&type=template&id=91bb4200"
import script from "./StudioAvatar.vue?vue&type=script&lang=js"
export * from "./StudioAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__